import "./footer.css";

export function Footer() {
  return (
    <div className="container- ">
      <div className=" Footer row">
        <div className="col-md-6 fs-6 text">
          <a
          
            className="text d-flex text-start  p-2"
            data-bs-toggle="modal"
            data-bs-target="#offerta"
          >
            Договор-оферта на оказание услуг
          </a>

          <div
            class="modal fade"
            id="offerta"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 className="modal-title fs-6" id="exampleModalLabel">
                    ДОГОВОР-ОФЕРТА НА ОКАЗАНИЕ УСЛУГ
                  </h1>
                  <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Закрыть"
                  ></button>
                </div>
                <div className="modal-body text-start fs-6">
                  Фотограф Дудина Людмила Витальевна (далее — Исполнитель), с
                  одной стороны, публикует настоящий договор-оферту об оказании
                  Услуг, являющийся предложением в адрес третьих лиц (далее —
                  Заказчик) в соответствии с пунктом 2 статьи 437 Гражданского
                  Кодекса Российской Федерации (ГК РФ). <br />
                  1. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ
                  <br />
                  1.1. «Оферта» — настоящее предложение, содержащее все
                  существенные условия договора, из которого усматривается воля
                  Исполнителя на заключение договора на указанных в настоящем
                  предложении условиях с любым лицом, кто отзовётся; 
                  <br />
                  1.2. «Сайт
                  Исполнителя» — сайт, расположенный по адресу: miladuph.ru;
                  <br />
                  1.3. «Акцепт Оферты» — совершение Заказчиком действий,
                  указанных в настоящей Оферте, свидетельствующих о принятии
                  данным лицом условий Оферты в полном объеме, в том числе,
                  совершении действий по выполнению указанных в настоящей Оферте
                  условий; 
                  <br />
                  1.4. «Заказчик» — совершеннолетнее дееспособное
                  физическое лицо, индивидуальный предприниматель или
                  юридическое лицо, заключивший Договор с Исполнителем в
                  результате Акцепта Оферты и, тем самым, получивший право
                  получать Услуги Исполнителя, и в полном объеме выполняющий
                  свои обязательства по Договору. 
                  <br />
                  1.5. «Исполнитель» — Фотограф
                  Дудина Людмила Витальевна.
                  <br />
                  1.6. «Договор» — означает настоящий
                  Договор-оферту на оказание Услуг, выбранных Заказчиком на
                  Сайте Исполнителя, заключенный между Исполнителем и Заказчиком
                  в результате Акцепта Заказчиком Оферты, наделяющий Исполнителя
                  и Заказчика правами и обязанностями, указанными в настоящей
                  Оферте. Любая ссылка в настоящей Оферте на Договор (статью
                  Договора) и/или его условия означает соответствующую ссылку на
                  настоящую Оферту и/или ее условия. 
                  <br />
                  1.7. «Стороны» — именуемые
                  совместно стороны Договора — Исполнитель и Заказчик. 
                  <br />
                  1.8.
                  «Услуга» / «Услуги» — деятельность Исполнителя, связанная с
                  оказанием услуг по фотосъемке, или проведению фотосессий; 
                  <br />
                  1.9.
                  «Фотография» — визуальное изображение на бумажном, прозрачном,
                  электронном носителях любого формата. 
                  <br />
                  1.10. «Исходные файлы» —
                  по-простому «исходники», сырые файлы, которые создаются в
                  процессе съёмки. Исходные файлы не имеют цветокоррекции и не
                  имеют ретуши. 
                  <br />
                  1.11. Условия выбранных Заказчиком Услуг
                  становятся частью Договора. 
                  <br />
                  2. ОБЩИЕ ПОЛОЖЕНИЯ 
                  <br />
                  2.1. Настоящая
                  оферта определяет все существенные условия договора между
                  Исполнителем и Заказчиком, в том числе, порядок оказания Услуг
                  Исполнителя. 
                  <br />
                  2.2. Оферта, а также вся информация об Услугах
                  Исполнителя: стоимость, виды и сроки оказания Услуг
                  опубликованы на Сайте Исполнителя. 
                  <br />
                  2.3. Договор не требует
                  скрепления печатями и/или подписания Заказчиком и Исполнителем
                  (далее по тексту — Стороны) и сохраняет при этом юридическую
                  силу. 
                  <br />
                  3. ПРЕДМЕТ ДОГОВОРА 
                  <br />
                  3.1. Исполнитель обязуется оказывать
                  Заказчику выбранные им Услуги. 
                  <br />
                  3.2. За Исполнителем
                  сохраняется неотчуждаемые авторские и имущественные права.
                  <br />
                  3.3. Исполнитель хранит отснятый материал в течение 60
                  календарных дней с момента предоставления Заказчику
                  результатов фотосъемки для возможного восстановления в случае
                  утери Заказчиком своего экземпляра. 
                  <br />
                  3.4. Исполнитель не отдает
                  необработанные фотографии Заказчику. 
                  <br />
                  3.5. Исполнитель не
                  отдает исходные файлы. 
                  <br />
                  3.6. Заказчик обязуется оплачивать
                  Услуги на условиях и в порядке, определенных настоящим
                  Договором. 
                  <br />
                  4. ПОРЯДОК ЗАКЛЮЧЕНИЯ ДОГОВОРА. СПОСОБЫ ОПЛАТЫ
                  УСЛУГ 
                  <br />
                  4.1. Надлежащим безоговорочным Акцептом настоящей Оферты
                  в соответствии со статьей 438 Гражданского кодекса Российской
                  Федерации является оплата Клиентом Услуг Исполнителя на
                  условиях 50(пятьдесят)% предоплаты. 
                  <br />
                  4.2. Стоимость Услуг и
                  описание предоставляемых Исполнителем Услуг публикуются на
                  Сайте Исполнителя. Оплачивая и/или заказывая Услуги, Заказчик
                  выражает полное и безоговорочное согласие с действующими на
                  момент оплаты условиями Оферты, частью которых являются
                  условия оказания Услуг. 
                  <br />
                  5. ПРАВА И ОБЯЗАННОСТИ СТОРОН 
                  <br />
                  5.1.
                  Заказчик обязуется: 
                  <br />
                  5.1.1. внести предоплату на Услуги в
                  порядке 50(пятьдесят)% предварительной оплаты до начала их
                  оказания; 50(пятьдесят)% стоимости Услуги Заказчик оплачивает
                  в день оказания Услуги. 
                  <br />
                  5.1.2. самостоятельно следить за
                  любыми обновлениями информации, размещаемой на Сайте
                  Исполнителя, в том числе, следить за изменениями условий
                  оказания Услуг, изменениями настоящего Договора и любых иных
                  материалов, которые прямо или косвенно связаны с оказанием
                  Услуги или влияют на них. Заказчик лишается права ссылаться на
                  отсутствие осведомленности об указанных изменениях, если такие
                  изменения размещены на Сайте Исполнителя; 
                  <br />
                  5.2. Заказчик имеет
                  право получать заказанную Услугу при условии ее
                  предварительной оплаты. 
                  <br />
                  5.3. Исполнитель обязуется: 
                  <br />
                  5.3.1.
                  организовать и оказать выбранную Заказчиком Услугу качественно
                  и с учетом описания Услуги, которая выбрана Заказчиком. 
                  <br />
                  5.3.2.
                  предоставить Заказчику необходимую и достоверную информацию о
                  предлагаемой работе. 
                  <br />
                  5.3.3. передать Заказчику результаты
                  выполненных работ в течении 5-10 рабочих дней. 
                  <br />
                  5.3.4.
                  выполнять работы с надлежащим качеством, соответствующим
                  фотографиям в портфолио, если данный вид съемки представлен в
                  портфолио. 
                  <br />
                  5.4. Исполнитель имеет право: 
                  <br />
                  5.4.1 отказать в
                  оказании Услуг без объяснения причины, до внесения предоплаты
                  и до оказания Услуг с возвратом предоплаты; 
                  <br />
                  5.4.2.
                  самостоятельно избирать форму оказания Услуг с учетом условий
                  оказания Услуг, выбранных Заказчиком; 
                  <br />
                  6. ОСОБЫЕ УСЛОВИЯ И
                  ОТВЕТСТВЕННОСТЬ СТОРОН 
                  <br />
                  6.1. Заказчик в полном объеме возмещает
                  убытки, причиненные Исполнителю нарушением условий Договора
                  Заказчиком или третьим лицом, в интересах которого Заказчиком
                  был заключен Договор. 
                  <br />
                  6.2. Стороны освобождаются от
                  ответственности за неисполнение или ненадлежащее исполнение
                  своих обязательств по Договору, если докажут, что надлежащее
                  исполнение оказалось невозможным вследствие обстоятельств
                  непреодолимой силы, которые стороны не могли предвидеть и
                  избежать — форс-мажорных обстоятельств. При этом наличие
                  форс-мажорных обстоятельств продлевает срок исполнения
                  Сторонами принятых на себя по Договору обязательств до
                  прекращения соответствующих форс-мажорных обстоятельств. В
                  случае если указанные обстоятельства действуют более чем 30
                  (тридцать) дней, Стороны имеют право в одностороннем порядке
                  расторгнуть настоящий Договор. 
                  <br />
                  6.3. Заказчик вправе после
                  оплаты Услуг не позднее чем за 3 (три) дня до начала оказания
                  Услуг, отказаться от исполнения настоящего Договора и
                  потребовать возврата оплаченной стоимости Услуг. 
                  <br />
                  6.4. В случае
                  отказа Заказчика от Услуг и от исполнения настоящего Договора
                  в иные сроки Исполнитель имеет право удержать понесенные им
                  расходы, произведенные для оказания Услуг Заказчику. 
                  <br />
                  7.
                  ПОРЯДОК РАССМОТРЕНИЯ ПРЕТЕНЗИЙ И СПОРОВ 
                  <br />
                  7.1. Все споры,
                  связанные прямо или косвенно с Офертой и Договором,
                  заключенным в результате Акцепта Оферты, или с качеством
                  оказания услуг, стороны решают путем переговоров. Если решение
                  спора путем переговоров не удается достичь, все споры подлежат
                  рассмотрению в суде по месту нахождения Исполнителя.
                  Соблюдение претензионного порядка разрешения спора Заказчиком
                  до обращения в суд является обязательным. 
                  <br />
                  8. СРОК ДЕЙСТВИЯ
                  ДОГОВОРА. ПОРЯДОК ИЗМЕНЕНИЯ И РАСТОРЖЕНИЯ 
                  <br />
                  8.1. Договор
                  вступает в силу с момента Акцепта настоящей Оферты в порядке,
                  установленном п. 4.1 Договора, и действует в течение срока
                  оказания Услуг в части обязательств по оказанию Услуг и в
                  течение иных сроков, если такие сроки, указаны в Оферте либо
                  до момента его расторжения по основаниям, предусмотренным
                  настоящим Договором, в том числе, в случае отсутствия
                  технической возможности оказания Услуг. 
                  <br />
                  8.2. Заказчик вправе
                  расторгнуть Договор в одностороннем порядке, сообщив об этом
                  Исполнителю в любой форме не позднее, чем за 3 (три) дня до
                  начала оказания Услуг. 
                  <br />
                  8.3. Исполнитель вправе расторгнуть
                  Договор в одностороннем порядке с возвратом предоплаты на
                  оказание Услуг, в любой момент. 
                  <br />
                  9. РЕКВИЗИТЫ ИСПОЛНИТЕЛЯ
                  Дудина Людмила Витальевна; Регистрация: г. Москва ИНН:
                  771574631418; Тел: +7 (929)950-09-32.
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Закрыть
                  </button>
                  <button type="button" class="btn btn-primary">
                    Сохранить изменения
                  </button>
                </div>
              </div>
            </div>
          </div>
      

        <a
          
          className="text d-flex text-start p-2"
          data-bs-toggle="modal"
          data-bs-target="#personal"
        >
          Согласие на обработку персональных данных
        </a>

        <div
          class="modal fade"
          id="personal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 className="modal-title fs-6" id="exampleModalLabel">
                  Согласие на обработку персональных данных
                </h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Закрыть"
                ></button>
              </div>
              <div className="modal-body text-start fs-6">
                Данное согласие об обработке персональных данных разработано в
                соответствии с законодательством Российской Федерации.
                Присоединяясь к настоящему Соглашению и оставляя свои данные на
                Сайте, путем заполнения полей онлайн-заявки (регистрации)
                Пользователь выражает Согласие на обработку персональных данных
                и их передачу оператору обработки персональных данных
                Самозанятой Дудиной Людмиле Витальевне: ИНН 771574631318 в
                дальнейшем – Оператору свое согласие на обработку своих
                персональных данных, как без использования средств
                автоматизации, так и с их использованием (далее – Согласие).
                Согласие дается в целях: 
                <br />
                - оформление заявки; 
                <br />
                - обеспечение
                соблюдения требований законодательства Российской Федерации; 
                <br />
                -
                ответы на запросы; 
                <br />
                - обеспечение работы Пользователя с Сайтом
                Оператора; 
                <br />
                - направление Пользователям аналитических материалов
                и информирование Пользователей о предстоящих мероприятиях,
                организуемых Оператором, а также регистрация Пользователей для
                участия в таких мероприятиях; 
                <br />
                - оплата услуг; 
                <br />
                - заключение и
                исполнение договора оказания услуг, в т.ч. доставка физических
                товаров; 
                <br />
                - установление обратной связи в целях: 
                <br />
                -оказания услуг;
                <br />
                -улучшения качества оказываемых услуг;
                <br />
                -улучшения качества Сайта
                и удобства его использования;
                <br />
                -выявления и устранения ошибок
                программного обеспечения. 
                <br />
                Пользователь: 
                <br />
                • подтверждает и
                признает, что им внимательно в полном объеме прочитано Согласие
                и условия обработки его персональных данных, указываемых им в
                полях онлайн заявки (регистрации), текст Соглашения и условия
                обработки персональных данных ему понятны; 
                <br />
                • выражает Согласие
                на обработку персональных данных без оговорок и ограничений
                (далее – Согласие). 
                <br />
                Моментом принятия Согласия является нажатие
                на кнопку отправки Формы на любой странице Сайта;
                <br />
                 •
                подтверждает, что, давая Согласие, он действует свободно, своей
                волей и в своем интересе; 
                <br />
                • Данное Согласие дается на обработку
                персональных данных как без использования средств автоматизации,
                так и с их использованием. 
                <br />
                Согласие дается на обработку
                следующих персональных данных: имя, мобильный телефон,
                электронный адрес, Сookie-файлы, IP-адрес. 
                <br />
                - то есть согласие на
                совершение действий, предусмотренных п. 3 ст. 3 Федерального
                закона от 27.07.2006 N 152-ФЗ «О персональных данных» Я
                предоставляю согласие на возможную передачу своих персональных
                данных третьим лицам, в т.ч. Оператору для исполнения целей
                обработки персональных данных. 
                <br />
                Данное согласие действует в
                течение неопределенного срока до отзыва согласия на обработку
                персональных данных. 
                <br />
                В указанных целях даю согласие на передачу
                моих персональных данных, указанных выше: 
                <br />
                - ООО «ВК», ИНН
                7743001840, ОГРН 1027739850962, адрес: г. Москва, Ленинградский
                проспект д.39, стр.79). 
                <br />
                - ООО «Сенлер», ИНН 4345518915, КПП
                434501001, ОГРН 1224300005038, адрес: 610002, Кировская область,
                г. Киров, ул. Альберта Лиханова, д.18, пом. 1003. 
                <br />
                - Сайт
                https://miladuph.ru 
                <br />
                Персональные данные обрабатываются в целях
                предоставления доступа к онлайн мероприятиям, проверки,
                исследования и анализа данных, позволяющих формированию базы
                данных Исполнителя. 
                <br />
                В ходе обработки с персональными данными
                будут совершены следующие действия: 
                <br />
                сбор; 
                <br />
                запись;
                <br />
                систематизация; 
                <br />
                накопление; 
                <br />
                хранение; 
                <br />
                уточнение (обновление,
                изменение); 
                <br />
                извлечение; 
                <br />
                использование; 
                <br />
                передачу (предоставление,
                доступ); 
                <br />
                обезличивание; 
                <br />
                блокирование; 
                <br />
                удаление; 
                <br />
                уничтожение. 
                <br />
                Я
                вправе отозвать данное согласие на обработку своих персональных
                данных, письменно уведомив об этом оператора. 
                <br />
                В случае отзыва
                согласия на обработку своих персональных данных Оператор обязан
                прекратить обработку персональных данных и уничтожить
                персональные данные в срок, не превышающий трех рабочих дней с
                даты поступления указанного отзыва. 
                <br />
                Об уничтожении персональных
                данных оператор обязан уведомить субъекта персональных данных.
                Персональные данные субъекта подлежат хранению в течение сроков,
                установленных законодательством Российской Федерации.
                Персональные данные уничтожаются: по достижению целей обработки
                персональных данных; при ликвидации или реорганизации оператора;
                на основании письменного обращения субъекта персональных данных
                с требованием о прекращении обработки его персональных данных
                (оператор прекратит обработку таких персональных данных в
                течение 3 (трех) рабочих дней, о чем будет направлено письменное
                уведомление субъекту персональных данных в течение 10 (десяти)
                рабочих дней. 
                <br />
                Сведения об Операторе:
                <br />
                 Самозанятая Дудина Людмила
                Витальевна ИНН 771574631318 AraneaPhoto@yandex.ru +79299500932
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Закрыть
                </button>
                <button type="button" class="btn btn-primary">
                  Сохранить изменения
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <div className="col-md-6 d-flex iconBlock">
        <a href="https://t.me/MilaDuPhotoPro" target="_blank">
          <i class="fab fa-telegram fs-3 iconk"></i>
        </a>
        <a href="https://vk.com/miladu_ph" target="_blank">
          <i class="fab fa-vk fs-3 iconk"></i>
        </a>
      </div>
    </div>
     </div>
  );
}
